import { panelRoute as route } from '@utils/consts';
import { signUpRoutes } from '@pages/signIn/routes';
import { adminsRoutes } from './admins/routes';
import { tenantsRoutes } from './tenants/routes';
import { workflowsRoutes } from './workflows/routes';

const routes = [
  {
    path: route.index,
    children: [
      {
        path: '',
        lazy: async () => {
          const { Panel } = await import('@pages/panel');
          return { Component: () => <Panel /> };
        },
      },
      ...signUpRoutes,
      ...adminsRoutes,
      ...tenantsRoutes,
      ...workflowsRoutes,
    ],
  },
];

export { routes as panelRoutes };
